// extracted by mini-css-extract-plugin
module.exports = {"container":"CutleryBanner_container__lSLlb","innerContainer":"CutleryBanner_innerContainer__eENV9","title":"CutleryBanner_title__oSAZZ"};